<template>
  <div class="c-filter">
    <div class="c-form">
      <ElForm inline class="elementui-common-form-styles" v-highlight>
        <ElFormItem>
          <el-select v-model="mediaIds" multiple collapse-tags filterable clearable placeholder="选择媒体">
            <el-option v-for="item in mediaData" :key="item.key" :value="item.key" :label="item.label"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="managerIds" multiple collapse-tags filterable clearable placeholder="选择管控人员">
            <el-option v-for="item in operatorData" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="upOpId" multiple collapse-tags filterable clearable placeholder="选择最后修改人">
            <el-option v-for="item in operatorData" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="mgameIds" multiple collapse-tags filterable clearable placeholder="选择中间件游戏">
            <el-option v-for="item in gameData" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="projectGroupIds" multiple collapse-tags filterable clearable placeholder="选择项目组">
            <el-option v-for="item in projectData" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="status" collapse-tags filterable clearable placeholder="选择任务状态">
            <el-option v-for="item in statusList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>
        <ElFormItem>
          <el-select v-model="platform" collapse-tags filterable clearable placeholder="选择平台">
            <el-option v-for="item in platformList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </ElFormItem>

        <ElFormItem class="bg-transparent">
          <div class="btns">
            <ElButton type="primary" @click="sendEvent">查询</ElButton>
            <ElButton @click="$emit('on-down')">人员管控导入模板</ElButton>&ensp;
            <Upload action="" :before-upload="preUpload" class="upload-btn" accept="application/vnd.ms-excel,.xls,.xlsx,.csv">
              <ElButton type="primary">批量导入管控</ElButton>&ensp;
            </Upload>
            <ElButton type="primary" @click="$router.push({ name: 'personalcontroladd' })">新建任务</ElButton>
          </div>
        </ElFormItem>
      </ElForm>
    </div>
  </div>
</template>
<script>
import promote_media from '@/data/promote_media'
const statusList = [
  { name: '启用中', id: 1 },
  { name: '已暂停', id: 0 }
]
const platformList = [
  { name: 'iOS', id: 2 },
  { name: '安卓', id: 1 }
]
export default {
  name: 'listFilter',
  props: {
    operatorData: {
      type: Array
    },
    gameData: {
      type: Array
    },
    projectData: {
      type: Array
    }
  },
  methods: {
    sendEvent() {
      const params = {
        mediaIdStr: this.mediaIds.length ? this.mediaIds.join(',') : undefined,
        opIdsStr: this.managerIds.length ? this.managerIds.join(',') : undefined,
        upOpIdStr: this.upOpId.length ? this.upOpId.join(',') : undefined,
        gameIdStr: this.mgameIds.length ? this.mgameIds.join(',') : undefined,
        projectGroupOpIds: this.projectGroupIds.length ? this.projectGroupIds.join(',') : undefined,
        status: this.status === '' ? undefined : this.status,
        platform: this.platform || undefined
      }
      this.$emit('on-change', params)
    },
    handleAgent(meta) {
      this.agentId = meta.id
    },
    handleGame(meta) {
      this.gameId = meta.id
    },
    preUpload(file) {
      this.$emit('on-upload', file)
      return false
    }
  },
  computed: {},
  watch: {},
  data() {
    return {
      keyword: '',
      managerIds: [],
      upOpId: [],
      status: '',
      mediaIds: [],
      mgameIds: [],
      projectGroupIds: [],
      statusList,
      platformList,
      platform: '',
      type: 1,
      mediaData: promote_media
    }
  },
  created() {
    this.sendEvent()
  }
}
</script>

<style lang="scss" scoped>
.btns {
  display: flex;
  ::v-deep .upload-btn {
    .ivu-upload-list {
      margin-top: 0;
    }
  }
}
</style>
